<template>
	<div>
		<div style="margin-bottom: 18px;margin-top: 18px;">
			<el-input v-model="name" placeholder="请输入名称" suffix-icon="el-icon-search" style="width: 200px;" size="small"
				@keyup.enter.native="getData"></el-input>

			<el-button type="primary" style="margin-left: 15px;" size="small" @click="getData">查询</el-button>
			<el-button type="success" style="margin-left: 15px;" size="small" @click="reset">重置</el-button>
			<el-button type="warning" style="margin-left: 15px;" size="small" @click="add">新增</el-button>
		</div>
		<el-table :data="tableData" :header-cell-style="{background:'#f2f5fc',color:'#55555'}" border
			highlight-current-row>
			<el-table-column prop="id" align="center" label="ID" width="60">
			</el-table-column>
			<el-table-column prop="account" align="center" label="账号" width="180">
			</el-table-column>
			<el-table-column prop="name" align="center" label="姓名" width="180">
			</el-table-column>
			<el-table-column prop="nickname" align="center" label="昵称" width="180">
			</el-table-column>
			<el-table-column prop="head" align="center" label="头像" width="80">
				<template slot-scope="scope">
					<el-image style="width: 50px; height: 50px" :src="scope.row.head"
						:preview-src-list="scope.row.srcList">
					</el-image>
				</template>
			</el-table-column>
			<el-table-column prop="integral" align="center" label="积分" width="80">

			</el-table-column>

			<el-table-column prop="code" align="center" label="注册码" width="80">

			</el-table-column>
			<el-table-column prop="roleId" align="center" label="角色" width="140">
				<template slot-scope="scope">
					<el-tag :type="scope.row.role == 1?'danger':'primary'" disable-transitions>
						{{ scope.row.roleName }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="createUserName" align="center" label="创建人" width="180">
			</el-table-column>
			<el-table-column prop="name" align="center" label="创建时间" width="180">
				<template slot-scope="scope">
					{{utils.formatTime(scope.row.createTime)}}
				</template>
			</el-table-column>
			<el-table-column prop="updateUserName" align="center" label="更新人" width="180">
			</el-table-column>
			<el-table-column prop="name" align="center" label="更新时间" width="180">
				<template slot-scope="scope">
					{{utils.formatTime(scope.row.updateTime)}}
				</template>
			</el-table-column>
			<el-table-column prop="operate" align="center" label="操作" width="180">
				<template slot-scope="scope">
					<el-button type="success" size="small" @click="mod(scope.row)">编辑</el-button>
					<el-popconfirm v-if="scope.row.role != 1" title="确定删除吗？" @confirm="deleteRow(scope.row)"
						style="margin-left: 10px;">
						<el-button type="danger" slot="reference" size="small">删除</el-button>
					</el-popconfirm>

				</template>
			</el-table-column>
		</el-table>

		<div style="align-content: center;text-align: center;margin: 20px;">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
				:page-sizes="[2, 5, 10, 20]" :page-size="10" layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</div>

		<el-dialog :title="textTitle" :visible.sync="centerDialogVisible" width="30%" center>
			<el-form ref="form" :model="form" :rules="rules" label-width="80px">

				<el-form-item label="姓名" prop="name">
					<el-col :span="20">
						<el-input v-model="form.name" :disabled="isDis"></el-input>
					</el-col>
				</el-form-item>

				<el-form-item label="头像" prop="url">
					<el-col :span="20">
						<!-- <el-input v-model="form.remark"></el-input> -->
						<el-upload class="avatar-uploader" :action="uploadUrl"
							:show-file-list="false" :on-success="handleAvatarSuccess"
							:before-upload="beforeAvatarUpload">
							<img v-if="form.head" :src="form.head" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-col>
				</el-form-item>


				<el-form-item label="账号" prop="account">
					<el-col :span="20">
						<el-input v-model="form.account" :disabled="isDis"></el-input>
					</el-col>
				</el-form-item>


				<el-form-item label="密码" prop="password">
					<el-col :span="20">
						<el-input v-model="form.password"></el-input>
					</el-col>

				</el-form-item>

				<el-form-item label="角色">
					<el-select v-model="form.role" placeholder="请选择角色权限">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="昵称" prop="nickname">
					<el-col :span="20">
						<el-input v-model="form.nickname"></el-input>
					</el-col>
				</el-form-item>

				<el-form-item label="注册码" prop="code">
					<el-col :span="20">
						<el-input v-model="form.code" :disabled="isDis"></el-input>
					</el-col>
				</el-form-item>

			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save">{{ btnText }}</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	export default {
		name: "UserMange",
		data() {
			return {
				rules: {
					name: [{
						required: true,
						message: '请输入名字',
						trigger: 'blur'
					}],
					role: [{
						required: true,
						message: '请选择角色',
						trigger: 'blur'
					}],
					account: [{
							required: true,
							message: '请输入账号',
							trigger: 'blur'
						},
						{
							min: 3,
							max: 8,
							message: '长度在 3 到 8 个字符',
							trigger: 'blur'
						}
					],
					password: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							min: 3,
							max: 8,
							message: '长度在 3 到 8 个字符',
							trigger: 'blur'
						}
					],
				},
				options: [],
				tableData: [],
				pageSize: 10,
				page: 1,
				total: 0,
				name: "",
				centerDialogVisible: false,
				form: {
					id: "",
					name: "",
					account: "",
					nickname: "",
					password: "",
					head: "",
					role: "",
				},
				btnText: "提 交",
				textTitle: "创建账号",
				isDis: false,
				user: JSON.parse(sessionStorage.getItem('CurUser')),
				uploadUrl: "https://xlhz.sxsla.cn/files/upload",
				fileList: [],
				fileList1: [],
				imageUrl: ''
			}
		},
		beforeMount() {
			// this.utils.Logger("1111111111111111");
			this.getData();
			this.getRole();
			// this.loadPost();
		},
		methods: {
			handleAvatarSuccess(res, file) {
				this.form.head = URL.createObjectURL(file.raw);
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;

				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			},
			mod(row) {
				this.isDis = true;
				this.form = row;
				this.form.role = parseInt(this.form.role);
				this.btnText = "保存";
				this.textTitle = '修改账号信息'
				this.centerDialogVisible = true;
			},
			deleteRow(row) {
				var that = this;
				this.utils.requestGet(this, "/user/delete", {
					"id": row.id
				}, function(res, total) {
					that.utils.showMessage("success", "删除成功");
					that.getData();
				});

			},
			resetForm() {
				this.$refs.form.resetFields();
			},
			save() {
				var that = this;
				this.$refs.form.validate((valid) => {
					if (valid) {
						if (that.btnText == "提交") {
							this.form.createUser = this.user.id + "";
							this.utils.requestPost(this, "/user/add", this.form, function(res, total) {
								that.centerDialogVisible = false;
								that.getData();
								that.utils.showMessage("success", "创建成功");
								that.form.role = "";
							});
						} else {
							this.form.updateUser = this.user.id + "";
							this.utils.requestPost(this, "/user/mod", this.form, function(res, total) {
								that.isDis = false;
								that.centerDialogVisible = false;
								that.getData();
								that.utils.showMessage("success", "修改成功");
							});
						}
					} else {
						that.utils.showMessage("error", "请输入正确的内容");
						return false;
					}
				});

			},
			add() {
				var that = this;
				this.isDis = false;
				this.btnText = "提交";
				this.textTitle = '添加账号信息'
				this.centerDialogVisible = true;
				this.$nextTick(() => {
					that.resetForm();
				})
			},
			reset() {
				this.name = "";
			},
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.getData();
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getData();
			},
			getData() {
				var that = this;
				var params = {
					"pageSize": this.pageSize,
					"pageNum": this.page,
					"param": {
						"name": this.name
					}
				};
				this.utils.requestPost(this, "/user/listPageC1", params, function(res, total) {
					that.tableData = res;
					that.total = total;
				});
			},
			getRole() {
				var that = this;
				var params = {
					"pageSize": 100,
					"pageNum": 1,
					"param": {

					}
				};
				this.utils.requestPost(this, "/role/getList", params, function(res, total) {
					that.options = [];
					for (var i = 0; i < res.length; i++) {
						var bean = {};
						bean.value = res[i].id;
						bean.label = res[i].name;
						that.options.push(bean);
					}
				});
			},
			loadPost() {
				this.utils.requestPost(this, "/user/listP", {}, function(res) {

				});
			}
		}
	}
</script>

<style scoped>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>
